import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './index.css'
import 'react-tooltip/dist/react-tooltip.css'

ReactDOM.render(<App />, document.getElementById('root'));